export const CPP_OPT_EST_RECEIVED = 'CPP_OPT_EST_RECEIVED'
export const CPP_OPT_RECEIVED = 'CPP_OPT_RECEIVED'
export const CPP_ACC_RECEIVED = 'CPP_ACC_RECEIVED'
export const CPP_OPT_UNLOADED = 'CPP_OPT_UNLOADED'
